// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'
import {  AppRoleDto } from './types';
import { TPerson } from '../../automationObjects/Agents/types';
import { TCompany } from '../../automationObjects/Agents/Organizations/Company/types';


// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.userAPiUrl,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: ['users','userAppRoles','userResourceGroups'],
  endpoints: (builder) => ({
    getUser: builder.query<TPerson, string>({
      query: (userId) => `users/${userId}`,
      providesTags: ['users'],
    }),
    getUsersAppRoles: builder.query<AppRoleDto[], string>({
      query: (userId) => `users/${userId}/appRoles`,
      providesTags: ['userAppRoles'],
    }),
    getUsersResourceGroups: builder.query<TCompany[], string>({
      query: (userId) => `users/${userId}/resourceGroups`,
      providesTags: ['userResourceGroups'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUserQuery,
  useGetUsersAppRolesQuery,
  useGetUsersResourceGroupsQuery
} = userApi